import { render, staticRenderFns } from "./publishPopup.vue?vue&type=template&id=6a7dedfc&scoped=true&"
import script from "./publishPopup.vue?vue&type=script&lang=js&"
export * from "./publishPopup.vue?vue&type=script&lang=js&"
import style0 from "./publishPopup.vue?vue&type=style&index=0&id=6a7dedfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7dedfc",
  null
  
)

export default component.exports